const auth = {
  state: {
    user: null,
    allUsers: null,
    company: null,
    constants: null,
    AllLeaves:null,
    userLeaves:null,
    allEmployees: null,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setAllUsers(state, payload) {
      state.allUsers = payload;
    },
    setCompany(state, payload) {
      state.company = payload;
    },
    setConstants(state, payload) {
      state.constants = payload;
    },
    setAllLeaves(state, payload) {
      state.AllLeaves = payload;
    },
    setUserLeaves(state, payload) {
      state.userLeaves = payload;
    },
    setEmployeeList(state, payload) {
      state.allEmployees = payload;
    },
    clearAuth(state) {
      state.user = null;
      state.company = null;
      state.allUsers = null;
      state.constants = null;
      state.AllLeaves = null;
      state.userLeaves = null;
      state.allEmployees = null;
    }
  },
  getters: {
    allUsers: state => () => state.allUsers,
    AllLeaves: state => () => state.AllLeaves,
    userLeaves: state => () => state.userLeaves,
    allEmployees: state => () => state.allEmployees,
  }
};

export default auth;



// WEBPACK FOOTER //
// ./src/store/modules/auth.js